import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SubmitFormRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SubmitFormResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const submitForm = (request: SubmitFormRequest, options?: CashRequestOptions) =>
  post<SubmitFormRequest, SubmitFormResponse>('/2.0/cash/submit-form', request, { ...options, rejectOnError: true })
